import apiClient from './api.service';
import type {
  LegalDocumentAdminItem,
  LegalDocumentType,
  LegalDocumentStatus,
  CreateLegalDraftRequest,
} from '../types/legalConsent.types';

class LegalAdminService {
  async listDocuments(filters?: {
    type?: LegalDocumentType;
    status?: LegalDocumentStatus;
  }): Promise<LegalDocumentAdminItem[]> {
    const response = await apiClient.get<{ data: { items: LegalDocumentAdminItem[] } }>(
      '/api/admin/legal-documents',
      { params: filters }
    );
    return response.data.data.items;
  }

  async createDraft(payload: CreateLegalDraftRequest): Promise<LegalDocumentAdminItem> {
    const response = await apiClient.post<{ data: LegalDocumentAdminItem }>(
      '/api/admin/legal-documents',
      payload
    );
    return response.data.data;
  }

  async publish(documentId: string): Promise<LegalDocumentAdminItem> {
    const response = await apiClient.post<{ data: LegalDocumentAdminItem }>(
      `/api/admin/legal-documents/${documentId}/publish`
    );
    return response.data.data;
  }

  async getHistory(type: LegalDocumentType): Promise<LegalDocumentAdminItem[]> {
    const response = await apiClient.get<{ data: { items: LegalDocumentAdminItem[] } }>(
      `/api/admin/legal-documents/history/${type}`
    );
    return response.data.data.items;
  }
}

export const legalAdminService = new LegalAdminService();
